// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowUp = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowUp = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowUp = _exports.ArrowUp = function ArrowUp(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M15.3441 8.95723C15.2404 9.06084 15.1042 9.11333 14.9679 9.11333C14.8317 9.11333 14.6954 9.06155 14.5918 8.95723L10.5326 4.89801V16.3873C10.5326 16.6811 10.2941 16.9196 10.0003 16.9196C9.70655 16.9196 9.46811 16.6811 9.46811 16.3873V4.8987L5.40891 8.95792C5.20098 9.16585 4.86387 9.16585 4.65595 8.95792C4.44802 8.74999 4.44802 8.41288 4.65595 8.20495L9.62352 3.23735C9.67248 3.18838 9.73131 3.14945 9.7966 3.12248C9.92647 3.06855 10.0734 3.06855 10.2032 3.12248C10.2685 3.14945 10.3275 3.18838 10.3765 3.23735L15.3441 8.20495C15.552 8.41288 15.552 8.7493 15.3441 8.95723Z",
      fill: "#212B36"
    }));
  };
});
